import { RequestDataDto } from "@app/core/dto/request-data.dto";
import { ActionCommand } from "../action-command-interface";
import { ActionCommandResponseDto } from "@app/core/dto/action-command-response.dto";
import { UrlParser } from "@app/core/utils/url-parser/url-parser";

export class NavigationRouterCommand implements ActionCommand {
    constructor(private renderEngineComponent:any) { }

    async execute(actionData: any, requestData: RequestDataDto): Promise<ActionCommandResponseDto> {
        const url:UrlParser = new UrlParser(actionData?.params?.url);
        const requestPath: string = url.getPathParams();

        this.renderEngineComponent.navigateTo([requestPath], {
            queryParams: actionData?.params?.queryParams,
        });
        return;
    }
}